export default __webpack_public_path__ + "static/media/YASH_R_KALYANSHETTY.492d91e0.JPG";